import { Observable } from 'rxjs';

import {
  AcquisitionEventsResponse,
  AcquisitionProvidersResponse,
  BleikPullSettings,
  BleikPullSettingsView,
  GetAcquisitionEventsParams,
} from '../../../interfaces/acquisition.interface';

/** Único punto de acceso a proveedores y bitácora de adquisición (`/acquisition`). Clase abstracta: es el token de inyección. */
export abstract class AcquisitionApiService {
  /** Proveedores con sus cuentas; solo lectura: cada proveedor necesita su driver en código. */
  abstract listProviders(): Observable<AcquisitionProvidersResponse>;

  /**
   * Pide traer del proveedor sus campos personalizados; requiere `manage_lead_acquisition_rules`.
   * Solo encola (202): los trae el proceso del pull y aparecen en `listProviders()` con su fecha.
   */
  abstract refreshCustomFields(code: string): Observable<{ provider: string }>;

  /** Contactos procesados por el pull, del más nuevo al más viejo. */
  abstract listEvents(params: GetAcquisitionEventsParams): Observable<AcquisitionEventsResponse>;

  /** Reglas del pull de Bleik y su catálogo de pipelines y etapas. */
  abstract getBleikSettings(): Observable<BleikPullSettingsView>;

  /** Guarda las reglas completas; requiere `manage_lead_acquisition_rules`. 422 por campo, 503 si Bleik no responde. */
  abstract updateBleikSettings(
    settings: BleikPullSettings,
  ): Observable<{ settings: BleikPullSettings }>;
}
